import { cn } from '@/lib/utils';

type AudioPlayerProps = {
  ref?: React.RefObject<HTMLAudioElement | null>;
  url: string;
  className?: string;
};

export function AudioPlayer({ ref, url, className }: AudioPlayerProps) {
  return (
    <audio ref={ref} controls className={cn('h-10', className)}>
      <source src={url} type='audio/wav' />
      Your browser does not support the audio element.
    </audio>
  );
}
